export const highlight_green = '#29dd41';
export const dark_green = '#003f31';
export const background_1_green = '#cbdbbe';
export const background_2_green = '#b0c6ac';
